export class SchemaRegistryConfigInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "url",
            "baseName": "url",
            "type": "string",
            "format": ""
        },
        {
            "name": "auth",
            "baseName": "auth",
            "type": "SchemaRegistryAuthConfigInput",
            "format": ""
        },
        {
            "name": "subjectNamingStrategy",
            "baseName": "subjectNamingStrategy",
            "type": "SubjectNamingStrategy",
            "format": ""
        },
        {
            "name": "evolutionMode",
            "baseName": "evolutionMode",
            "type": "SchemaEvolutionMode",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SchemaRegistryConfigInput.attributeTypeMap;
    }
    constructor() {
    }
}
